import React from 'react';
import { Helmet } from 'react-helmet-async';
import { DefaultTemplate } from 'views/templates/DefaultTemplate';
import { Typography } from 'views/components/atoms/Typography';
import { LinkText } from 'views/components/molecules/LinkText';
import { ROUTER_PATH } from 'views/constants';

export const NotFoundPage: React.FC = () => (
  <>
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <DefaultTemplate>
      <Typography el="p">404 not found</Typography>
      <LinkText to={ROUTER_PATH.home}>back to Home</LinkText>
    </DefaultTemplate>
  </>
);
